// extracted by mini-css-extract-plugin
export var infoItem = "_ta-2";
export var title = "_ta-0";
export var value = "_ta-1";